import dataAdapterIcon from '@/assets/images/dataAdapter.svg';
import dataStoresIcon from '@/assets/images/dataStores.svg';
import eventHandlersIcon from '@/assets/images/eventHandlers.svg';

export const MenuList = [
  {
    label: 'Data Adapter Jobs',
    key: '/adapter-services',
    icon: dataAdapterIcon
  },
  {
    label: 'Event Handlers',
    key: '/event-handlers',
    icon: eventHandlersIcon
  },
  {
    label: 'Data Stores',
    key: '/data-store',
    icon: dataStoresIcon
  }
];
